import {List, ListItem, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import {InfoIcon} from "lucide-react";
import SteddiContainer from "../../General/SteddiContainer";
import React from "react";
import EnergiKonto from "../InfoItems/EnergiKonto";

export default function EnergiKontoPage() {
  return (
    <>
      <SteddiContainer padding="sm" background={"tertiary"}>
        <EnergiKonto/>
      </SteddiContainer>
      <List>
        <ListItem>
          <ListItemAvatar>
            <InfoIcon/>
          </ListItemAvatar>
          <ListItemText>
            <Typography>
              Stemmer ikke adressen? Gå tilbake til Min side hos strømleverandøren din og velg riktig adresse der.
            </Typography>
          </ListItemText>
        </ListItem>
      </List>
    </>
  )
}